<template>
		<el-col align="end" style="margin-bottom: 30px;">
				<el-table :data="data.slice((currentPage-1)*sizePrePage,currentPage*sizePrePage)"
									ref="commonTable"
									border
									
									:row-key="rowKey"
									:highlight-current-row="highlightCurrentRow"
									@current-change="$emit('current-change',$event)"
									@selection-change="$emit('selection-change',$event)"
									:header-cell-style="{background:'#eef1f6',color:'#606266'}">
						<slot></slot>
				</el-table>
				<el-row type="flex" justify="end" align="middle">
						<el-pagination
								v-if="!showMoreBtn"
								:current-page.sync="currentPage"
								:page-size="sizePrePage"
								layout="total, prev, pager, next"
								:total="data.length">
						</el-pagination>
						<el-button v-else @click="onClickMore" type="text" style="margin: 10px 10px;">更多...</el-button>
						<div v-if="!!cornerText" style="margin: 0 10px;">{{cornerText}}</div>
				</el-row>
		</el-col>

</template>

<script>
export default {
		name: "CommonTable",
		props: {
				data: {
						type: Array,
						default() {
								return [];
						},
						required: true
				},
				rowKey: {
						type:Function,
						default(row) {
								return row.id;
						}
				},
				cornerText: String,
				highlightCurrentRow: Boolean,
				sizePrePage: {
						type: Number,
						default: 10,
				},
				showMoreBtn: {
						type: Boolean,
						default: false
				}
		},
		watch: {
				currentPage(newValue) {
						console.log('currentPage', newValue);
				},
				sizePrePage(newValue) {
						console.log('sizePrePage', newValue);
				},

		},
		created() {
		},
		data() {
				return {
						currentPage: 1,
				};
		},
		methods: {
				onClickMore() {
						this.$emit('more');
				}
		}
}
</script>

<style scoped>
/* .el-table{
    width:99.9%!important;
	min-height:20px;
}
.el-main{
	overflow-x: hidden;
} */
</style>